export default __webpack_public_path__ + "static/media/postregCharacter.928c00bb.png";